export default "__VITE_ASSET__58320b1a__"